import { render } from "./AddTk.vue?vue&type=template&id=a9bd0ab0"
import script from "./AddTk.vue?vue&type=script&lang=js"
export * from "./AddTk.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__